export default __webpack_public_path__ + "static/media/working.b2bec113.gif";